const httpClient = (function () {

	const t = {};
	let sessionData = {
		token: ''
	};

	/**
	 * Perform GET request.
	 * @param {string} url
	 * @param params
	 * @returns {Promise<object>} - JSON object
	 */
	t.get = (url,params = null) => {
		let fullUrl = url;
		if(params !== null){
            fullUrl = url+'?'+urlEncode(params);
        }
		return performRequest("GET", fullUrl);
	};

	/**
	 * @return {{token: string}}
	 */
	t.getSessionData = () => {
		return sessionData;
	};

	/**
	 * Perform POST request.
	 * @param {string} url
	 * @param {object} data
	 * @param {boolean} json
	 * @returns {Promise<object>} - JSON object
	 */
	t.post = (url, data, json = false) => {
		return performRequest("POST", url, data, json);
	};

	/**
	 * Peform PUT request.
	 * @param {string} url
	 * @param {object} data
	 * @param {boolean} json
	 * @returns {Promise<object>} - JSON object
	 */
	t.put = function (url, data, json = false) {
		return performRequest("PUT", url, data, json);
	};

	t.delete = function (url) {
		return performRequest("DELETE", url);
	};

	t.login = function (params) {
		return t.post("/login", params);
	};

	/**
	 * Method used internally to perform HTTP requests.
	 * @param {string} method - HTTP verb
	 * @param {string} url 
	 * @param {object} [data=null]
	 * @param {boolean} [json=undefined]
	 */
	function performRequest(method, url, data = null, json) {

		const headers = new Headers();
		headers.append("Accept", "application/json");

		const fetchOptions = {
			method: method,
			headers: headers,
			credentials: 'include' // Send cookies with requests
		};

		if (data) {
			if (json) {
				fetchOptions.body = JSON.stringify(data);
				headers.append("Content-Type", "application/json");
			} else {
				fetchOptions.body = urlEncode(data);
				headers.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
			}
		}

		return fetch(url, fetchOptions)
			.then(response => {
				if (response.status !== 200) {
					throw new Error(`Bad status: ${response.status}`);
				}
				return response.json();
			})
			.then(json => {

				if (json.result === "error") {
					throw new Error(json.message);
				}

				if (json.result !== "ok") {
					throw new Error("Not OK");
				}

				return json;

			}).catch(error => {
				throw new Error(error);
			});

	}

	function urlEncode(data) {
		return Object.keys(data)
			.map(key => {
				return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
			})
			.join("&");
	}
	return t;

})();
